// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"168":"00054add8e6d419b2054","524":"fcc908b6e9a4106b6787"}[chunkId] + ".js";
};